import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MAX_LOGIN_ATTEMPTS, LOCKOUT_DURATION, STORAGE_KEYS } from './constants';
import api from './utils/api';
import './MainPage.css';

function MainPage() {
  const [roomId, setRoomId] = useState('');
  const [error, setError] = useState('');
  const [attempts, setAttempts] = useState(0);
  const navigate = useNavigate();
  
  useEffect(() => {
    const lockoutTime = localStorage.getItem(STORAGE_KEYS.LOCKOUT_TIME);
    if (lockoutTime && Date.now() < parseInt(lockoutTime)) {
      const remainingTime = Math.ceil((parseInt(lockoutTime) - Date.now()) / (1000 * 60 * 60));
      setError(`Locked out. Try again in ${remainingTime} hours.`);
    } else {
      localStorage.removeItem(STORAGE_KEYS.LOCKOUT_TIME);
    }
  }, []);

  const handleCreateGame = () => {
    navigate('/create-game');
  };

  const handleJoinRoom = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    const lockoutTime = localStorage.getItem(STORAGE_KEYS.LOCKOUT_TIME);
    if (lockoutTime && Date.now() < parseInt(lockoutTime)) {
      setError('You are locked out. Try again later.');
      return;
    }

    const result = await api.getRoom(roomId);
    
    if (result.success && result.data.exists) {
      navigate(`/game/${roomId}`);
      setAttempts(0);
    } else {
      handleFailedAttempt();
    }
  };

  const handleFailedAttempt = () => {
    const newAttempts = attempts + 1;
    setAttempts(newAttempts);
    
    if (newAttempts >= MAX_LOGIN_ATTEMPTS) {
      const lockoutTime = Date.now() + LOCKOUT_DURATION;
      localStorage.setItem(STORAGE_KEYS.LOCKOUT_TIME, lockoutTime.toString());
      setError('Too many failed attempts. Locked out for 24 hours.');
    } else {
      setError(`Invalid room ID. ${MAX_LOGIN_ATTEMPTS - newAttempts} attempts remaining.`);
    }
  };

  return (
    <div className="main-page">
      <h2>🎮 Welcome to Online Board Games</h2>

      <div className="actions-container">
        <div className="action-card">
          <h3>🎲 Create New Game</h3>
          <button onClick={handleCreateGame} className="create-game-btn">
            Create Game Room
          </button>
        </div>

        <div className="action-card">
          <h3>🚪 Join Game Room</h3>
          <form onSubmit={handleJoinRoom} className="join-form">
            <div className="input-group">
              <input
                type="text"
                className="room-input"
                placeholder="ROOM ID"
                value={roomId}
                onChange={(e) => setRoomId(e.target.value.toUpperCase())}
                maxLength={5}
                required
              />
              <button type="submit" className="join-btn">
                Join
              </button>
            </div>
            {error && <div className="error-message">{error}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default MainPage;
